// Vendors
import React from 'react';
import InputMask from 'react-input-mask';

const AccountForm = ({
  userMeta,
  requiredFieldsOK,
  handleInputChange,
  handleChangeView,
  handleSaveUserMeta
}) => {
  const allStates = window.wlUSStates;

  return (
    <div id="user-details">
      <div className="grid u--font-size-lg" style={{ maxWidth: '600px' }}>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">
              First Name
            </label>
            <input
              type="text"
              name="first_name"
              className="form__input"
              value={userMeta.first_name}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Last Name</label>
            <input
              type="text"
              name="last_name"
              className="form__input"
              value={userMeta.last_name}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Email</label>
            <input
              type="email"
              name="user_email"
              className="form__input"
              value={userMeta.user_email}
              disabled={true}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Phone</label>
            <input
              type="text"
              name="phone"
              className="form__input"
              value={userMeta.phone}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Company</label>
            <input
              type="text"
              name="company"
              className="form__input"
              value={userMeta.company}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Address</label>
            <input
              type="text"
              name="address"
              className="form__input"
              value={userMeta.address}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field">
            <label className="form__label u--font-weight-bold">Address</label>
            <input
              type="text"
              name="address2"
              className="form__input"
              value={userMeta.address2}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">City</label>
            <input
              type="text"
              name="city"
              className="form__input"
              value={userMeta.city}
              onChange={(event) => handleInputChange(event)}
            />
          </div>
        </div>

        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">State</label>
            <div className="form__select form__select--lg form__input--no-shadow">
              <select
                name="state"
                className="form__input form__input--lg"
                value={userMeta.state}
                onChange={(event) => handleInputChange(event)}
              >
                {allStates &&
                  Object.keys(allStates).map((singleState, index) => (
                    <option key={index} value={singleState}>
                      {allStates[singleState]}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </div>
        <div className="grid__col-xs-12">
          <div className="form__field form__field--required">
            <label className="form__label u--font-weight-bold">Zip</label>
            <InputMask
              type="text"
              name="zip_code"
              className="form__input"
              onChange={(event) => handleInputChange(event)}
              value={userMeta.zip_code}
              mask="99999"
            />
          </div>
        </div>
        <div className="grid__col-xs-12">
          <button
            id="pip-save-usermeta"
            className="btn btn--gold btn--md module-hover-root"
            type="button"
            disabled={requiredFieldsOK === false}
            onClick={() => handleSaveUserMeta()}
          >
            <span className="btn__content">
              <span className="btn__text">Save User Data</span>
            </span>
          </button>
          <br />
          <button
            className="btn btn--white btn--md module-hover-root u--margin-top-20"
            type="button"
            onClick={() => handleChangeView()}
          >
            <span className="btn__content">
              <span className="btn__text">Back to My Account Overview</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountForm;
